'use client';

import { createPage } from '@/app/_shared/utils/dynamicImports';

const Trending = createPage(
	() => import('@/features/discover/components/Trending'),
);

export default function TrendingPage() {
	return <Trending />;
}
